/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_LeadInputs */

const en_mk_sol_lembaga_lead = /** @type {(inputs: Mk_Sol_Lembaga_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six programmes running with a small core team and many volunteers. Reporting obligations to funders are non-negotiable, while the people to do them are always short.`)
};

const id_mk_sol_lembaga_lead = /** @type {(inputs: Mk_Sol_Lembaga_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam program berjalan dengan tim inti kecil dan banyak relawan. Kewajiban pelaporan ke pemberi dana tidak bisa ditawar, sementara orang yang mengerjakannya selalu kurang.`)
};

/**
* | output |
* | --- |
* | "Six programmes running with a small core team and many volunteers. Reporting obligations to funders are non-negotiable, while the people to do them are alway..." |
*
* @param {Mk_Sol_Lembaga_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_lead = /** @type {((inputs?: Mk_Sol_Lembaga_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_lead(inputs)
	return en_mk_sol_lembaga_lead(inputs)
});